<template>
  <footer class="footer">
    <div class="footer-content">
       <div class="footer-section left">
         <h3 class="section-title">产品与服务</h3>
         <div class="service-row">

           <div class="service-group">
             <h4 class="service-title">智慧法规库</h4>
             <ul class="service-list">
               <li>· 生命周期全覆盖</li>
               <li>· 法规高效追踪</li>
               <li>· 专研AI在线解答</li>
             </ul>
           </div>

           <div class="service-group">
             <h4 class="service-title">多语言文件转换</h4>
             <ul class="service-list">
               <li>· 服务介绍</li>
               <li>· 全流程质控</li>
               <li>· 适用场景</li>
             </ul>
           </div>

          
         </div>

         <div class="service-row">
          <div class="service-group">
             <h4 class="service-title">医疗器械行业数据</h4>
             <ul class="service-list">
               <li>· 服务介绍</li>
               <li>· 优势分析</li>
             </ul>
           </div>

           <div class="service-group">
             <h4 class="service-title">医疗器械注册服务</h4>
             <ul class="service-list">
               <li>· NMPA注册服务流程</li>
               <li>· 您身边的医疗器械法规专家</li>
               <li>· 注册服务及优势</li>
             </ul>
           </div>
          
         </div>
         <div class="service-row">
            <div class="service-group">
             <h4 class="service-title">行业资讯跟踪</h4>
             <ul class="service-list">
               <li>· 服务介绍</li>
               <li>· 适用场景</li>
             </ul>
           </div>
           
         </div>
       </div>
 
        <div class="footer-section company-section">
          <h3 class="section-title left">公司介绍</h3>
          <div class="company-content">
            <h4 class="service-title left">数量级</h4>
            <h4 class="service-title left">发展历程</h4>
            <h4 class="service-title left">服务优势</h4>
            <h4 class="service-title left">合作伙伴</h4>
            
          </div>
        </div>

      <div class="footer-section right">
        <h3 class="section-title">联系我们</h3>
        <div class="right-main">
          <div class="left">
            <div class="contact-item">
              <span class="contact-label">售前咨询</span>
              <span class="contact-value">+86 139 1183 4340</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">商务合作</span>
              <span class="contact-value">+86 139 1183 4340</span>
            </div>
            <div class="contact-item">
              <span class="contact-label">售后服务与投诉</span>
              <span class="contact-value">+86 188 4589 3490</span>
            </div>
           
          </div>
          <div class="right">
            <div class="contact-item">
              <span class="contact-label">微信小程序</span>
            </div>
            <div class="qr-code">
              <img src="https://boling-cloud.oss-cn-beijing.aliyuncs.com/dist/img/qrcode.jpg" alt="微信小程序二维码" class="qr-image">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="company-info">
        <span class="info-item">公司名称：北京安楹康思医学科技有限公司Anwin Cons Ltd.</span>
        <span class="info-item">办公地址：北京市朝阳区西大望路合生汇写字楼5层</span>
        <span class="info-item">E-mail：service@msecu.com</span>
      </div>
    </div>
  </footer>
</template>

<script setup>
</script>

<style lang="less" scoped>
.footer {
  background-color: #f5f5f5;
  border-top: 2px solid #e0e0e0;
  padding: 40px 0 0 0;

  .footer-content {
    width: 1400px;
    margin: 0 auto;
    display: flex;
  }

  .footer-section {
    width: 180px;
    display: flex;
    flex-direction: column;
    &.left {
      width: 660px;
      padding-right: 100px;
    }
    &.right {
      width: 560px;
    }
  }

  .section-title {
    font-size: 24px;
    font-weight: 600;
    color: #101010;
    margin: 0 0 24px 0;
    &.left {
      text-align: left;
    }
  }

  .service-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-bottom: 12px;
  }

  .service-group {
    margin-bottom: 0;
    text-align: left;
  }

  .service-title {
    font-size: 18px;
    line-height: 30px;
    font-family: sc-regular;
    font-weight: bold;
    color: #101010;
    margin: 0 0 10px 0 ;
    &.left {
      text-align: left;
      margin-bottom: 0;
    }
  }

  .service-list {
    list-style: none;
    padding: 0;
    margin: 0;
    font-size: 16px;
    color: #101010;
    font-family: sc-regular;
    line-height: 30px;
    text-align: left;
  }

  .service-list li {
    margin-bottom: 2px;
  }

  .right-main {
    display: flex;
    justify-content: center;
    gap: 40px;
    align-items: flex-start;
  }

  .contact-item {
    margin-bottom: 12px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .contact-label {
    display: inline-block;
    font-size: 18px;
    line-height: 30px;
    color: #101010;
    font-family: sc-regular;
    font-weight: bold;
  }

  .contact-value {
    font-size: 16px;
    color: #101010;
    line-height: 26px;
    font-family: sc-regular;
  }

  .qr-image {
    width: 160px;
    height: 160px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .footer-bottom {
    background-color: #5A5E66;
    color: #fff;
    padding: 20px 0;
    margin-top: 40px;
  }

  .company-info {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    font-family: sc-regular;
  }

  .info-item {
    color: #fff;
    font-size: 16px;
  }

  .company-section {
    .company-content {
      display: flex;
      flex-direction: column;
      gap: 10px;

    }
  }
}


// 小分比率适配
@media screen and (max-width: 1560px) {
  .footer {
    .footer-content, .company-info {
      width: 1200px;
    }

    .footer-section {
      &.left {
        width: 580px;
        padding-right: 100px;
      }
      &.right {
        width: 500px;
      }
    }

    .section-title {
      font-size: 22px;
    }
    .service-title, .contact-label {
      font-size: 17px;
      line-height: 28px;
    }
    .service-list, .contact-value, .company-info, .info-item  {
      font-size: 15px;
      line-height: 25px;
    }
  }
}

// 小分比率适配
@media screen and (max-width: 1400px) {
  .footer {
    .footer-content, .company-info {
      width: 1080px;
    }

    .footer-section {
      &.left {
        width: 520px;
        padding-right: 100px;
      }
      &.right {
        width: 450px;
      }
    }

    .section-title {
      font-size: 20px;
    }
    .service-title, .contact-label {
      font-size: 16px;
      line-height: 25px;
    }
    .service-list, .contact-value, .company-info, .info-item  {
      font-size: 14px;
      line-height: 23px;
    }
  }
}
</style>